import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractFiltersComponent } from './contract-filters.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DCSelectModule } from '@dc/ui/components/select/select.module';
import { DCDatepickerModule } from '@dc/ui/components/datepicker/datepicker.module';
import { DCButtonModule } from '@dc/ui/components/button/button.module';
import { DCLoadingModule } from '@dc/ui/components/loading/loading.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';



@NgModule({
    declarations: [
        ContractFiltersComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DCSelectModule,
        DCDatepickerModule,
        DCButtonModule,
        DCLoadingModule,
        PerfectScrollbarModule
    ],
    exports: [
        ContractFiltersComponent
    ]
})
export class ContractFiltersModule { }
